import React from 'react';
import { useNavigate } from 'react-router-dom';
import { fmtDate } from '../../utils/helpers';

export default function DashboardDesktop({ vm }) {
  const { event, cards, mySide, isMarriage } = vm;
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-head">
        <h1>Dashboard</h1>
        {/* The side is the signed-in user's own (My Profile) — nothing to pick here. */}
        {isMarriage && mySide && (
          <span className={mySide === 'Groom' ? 'chip male' : 'chip female'}>{mySide} side</span>
        )}
        <div className="spacer" />
        <span className="muted">{event?.EventName || 'Select event'}</span>
      </div>

      <div className="grid kpi" style={{ marginBottom: 18 }}>
        {cards.map((card, index) => (
          <button
            key={index}
            type="button"
            className="kpi-card kpi-link"
            style={{ background: card.g }}
            onClick={() => card.to && navigate(card.to)}
          >
            <div className="n">{card.n}</div>
            <div className="l">{card.l}</div>
          </button>
        ))}
      </div>

      {event && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="card-pad">
            <strong>{event.EventName}</strong>
            <div className="muted" style={{ marginTop: 4, fontSize: 13 }}>
              {event.EventTypeName || event.EventType} | {fmtDate(event.EventStartDate)} to {fmtDate(event.EventEndDate)} | {event.Venue || ''} {event.City || ''}
            </div>
            {isMarriage && (
              <div style={{ marginTop: 8, fontSize: 13 }}>
                <span className="chip male" style={{ marginRight: 8 }}>Groom: {event.MaleSideName || '-'}</span>
                <span className="chip female">Bride: {event.FemaleSideName || '-'}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
